import { useCallback } from 'react';
import type { SubmitHandler } from 'react-hook-form';

import { useUserProfile } from 'contexts/UserProfileContext';
import usePushNotifications from 'hooks/common/usePushNotifications';

import type { EditUserFormValuesT } from '../declarations';

type useProfilePageT = {
  handleSubmitForm: SubmitHandler<EditUserFormValuesT>;
  handleDeleteImgBtnClick: () => void;
};

const useProfilePage = (): useProfilePageT => {
  /**
   * Hooks
   */
  const { updateUser, deleteUserPhoto } = useUserProfile();
  usePushNotifications();

  /**
   * Handlers
   */
  const handleDeleteImgBtnClick = (): void => {
    deleteUserPhoto();
  };

  const handleSubmitForm = useCallback(
    (userData: EditUserFormValuesT) => {
      updateUser(userData);
    },
    [updateUser]
  );

  return {
    handleSubmitForm,
    handleDeleteImgBtnClick,
  };
};

export default useProfilePage;
